import moment from 'moment';
import { PartnershipApplicationStatus } from '@/helpers/entities/enums/v2/PartnershipApplicationStatus';
import { BrandModel } from '@/helpers/entities/models/BrandModel';
export class PartnershipApplicationsByStatusModel {
    constructor(payload) {
        Object.assign(this, payload);
        this.brand = new BrandModel(payload.brand);
    }
    get clientName() {
        return `${this.firstName} ${this.lastName}`;
    }
    get formattedCreatedAt() {
        const placedAt = new Date(this.createdAt);
        return moment(placedAt).format('LLL');
    }
    /**
     * Alias to Pending Application Status
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.22.0}
     */
    get pending() {
        return this.status === PartnershipApplicationStatus.Pending;
    }
    /**
     * Alias to Rejected Application Status
     * @author Peter John Alvarado <peterjohn@gorated.ph>
     * @since Version {0.22.0}
     */
    get rejected() {
        return this.status === PartnershipApplicationStatus.Rejected;
    }
}
